module.exports = __webpack_public_path__ + "media/common/images/logo-f1c53e242b538e06f4932a606f4ca327.png";